export default __webpack_public_path__ + "static/media/Core-Values-05.b4d16018.png";